import type { ContractDocument } from "../types/contractDocument";

/** Fallback mocks: `status` is business state; `stage` drives view/open (matches API contracts). */
export const mockContractDocuments: ContractDocument[] = [
  {
    id: "cd-001",
    documentName: "Commercial_Insurance_Master_Agreement_2025.docx",
    contractType: "Partnership Agreement",
    status: "Approved",
    stage: "Review",
    createdBy: "Sarah Johnson",
    createdByEmail: "sarah.johnson@tmhcc.com",
    createdDate: "02-22-2025"
  },
  {
    id: "cd-002",
    documentName: "Property_Liability_Service_Contract_Q1.pdf",
    contractType: "Partnership Agreement",
    status: "Approved",
    stage: "Review",
    createdBy: "Lisa Anderson",
    createdByEmail: "lisa.anderson@tmhcc.com",
    createdDate: "02-21-2025"
  },
  {
    id: "cd-003",
    documentName: "Healthcare_Provider_Partnership_Agreement.pdf",
    contractType: "Partnership Agreement",
    status: "Approved",
    stage: "Completed",
    createdBy: "Michael Chen",
    createdByEmail: "michael.chen@tmhcc.com",
    createdDate: "02-20-2025"
  },
  {
    id: "cd-004",
    documentName: "Auto_Insurance_Supply_Contract_Final.pdf",
    contractType: "Master Service Agreement",
    status: "Approved",
    stage: "Queued",
    createdBy: "John Smith",
    createdByEmail: "john.smith@tmhcc.com",
    createdDate: "02-19-2025"
  },
  {
    id: "cd-005",
    documentName: "Professional_Indemnity_License_Agreement.pdf",
    contractType: "Master Service Agreement",
    status: "Approved",
    stage: "Review",
    createdBy: "Sarah Johnson",
    createdByEmail: "sarah.johnson@tmhcc.com",
    createdDate: "01-18-2025"
  },
  {
    id: "cd-006",
    documentName: "Workers_Comp_Master_Service_Agreement.pdf",
    contractType: "Partnership Agreement",
    status: "Approved",
    stage: "Completed",
    createdBy: "John Smith",
    createdByEmail: "john.smith@tmhcc.com",
    createdDate: "01-17-2025"
  },
  {
    id: "cd-007",
    documentName: "Umbrella_Coverage_Partnership_Contract.pdf",
    contractType: "Partnership Agreement",
    status: "Approved",
    stage: "Review",
    createdBy: "Lisa Anderson",
    createdByEmail: "lisa.anderson@tmhcc.com",
    createdDate: "02-16-2025"
  },
  {
    id: "cd-008",
    documentName: "Cyber_Security_License_Agreement_v2.docx",
    contractType: "Partnership Agreement",
    status: "Approved",
    stage: "PIIInProcess",
    createdBy: "Robert Wilson",
    createdByEmail: "robert.wilson@tmhcc.com",
    createdDate: "02-15-2025"
  },
  {
    id: "cd-009",
    documentName: "Directors_Officers_Supply_Agreement.pdf",
    contractType: "Supply Agreement",
    status: "Approved",
    stage: "Review",
    createdBy: "Emily Davis",
    createdByEmail: "emily.davis@tmhcc.com",
    createdDate: "02-14-2025"
  },
  {
    id: "cd-010",
    documentName: "General_Liability_Master_Contract_2025.pdf",
    contractType: "License Agreement",
    status: "Approved",
    stage: "Completed",
    createdBy: "Robert Wilson",
    createdByEmail: "robert.wilson@tmhcc.com",
    createdDate: "02-13-2025"
  }
];
